import React from 'react';
import MUIDataTable, { MUIDataTableColumnDef, MUIDataTableOptions } from "mui-datatables";
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';

const theme = () =>
    createTheme({
        overrides: {
            MUIDataTable: {
                root: {
                },
                paper: {
                    boxShadow: 'none',
                },
            },
            MUIDataTableHeadCell: {
                fixedHeader: {
                    top: '0px',
                    'z-index': '1',
                    position: 'sticky',
                    backgroundColor: '#fff',
                }
            }
        },
    });

interface CustomDataTableProps {
    title: string | React.ReactNode;
    data: Array<object | number[] | string[]>;
    columns: MUIDataTableColumnDef[];
    options?: MUIDataTableOptions | undefined;
}

export default function CustomDataTable({ title, columns, data, options }: CustomDataTableProps) {
    return (
        <MuiThemeProvider theme={theme}>
            <MUIDataTable title={title} data={data} columns={columns} options={options} />
        </MuiThemeProvider>
    );
}
